const Welcome = () => {

    return (
        <>
        <br/>
        <h3 style={{textAlign: 'center'}}>Thank you for taking part in the study</h3>
        <br/>
        </>
    );
  };
  
  export default Welcome;